


export const services = [
  {
 
    title: "Hidratantes",
    text: "72 horas de hidratação intensa, pele nutrida e saudável, proteção contra o ressecamento, rápida absorção, pele firme e sedosa, sensacão não oleosa",
  },
  {

    title: "Dermopés",
    text: "Possui ação anti-irritante, acelera a regeneração e melhora a umectação da pele. Auxilia no combate á inflamação, controla a oleosidade. Um poderoso regenerador cutâneo e umectante",
  },
  {

    title: "Antiacne",
    text: "A fórmula com melaleuca possui ação cicatrizante e anti-inflamatória que previne o surgimento de cravos e espinhas, reduzindo a presença de bactérias na pele",
  },
  {

    title: "Protetor Solar",
    text: "A linha de proteção solar oferece proteção ideal em todos os momentos do dia para toda a familia. Com ativos eficazes e de alta qualidade, protege dos raios solares e retarda o envellhecimento da pele",
  },
  {

    title: "Rosa Mosqueta",
    text: "Desenvolvida com o Óleo de Rosa Mosqueta e ativos naturais, a linha auxilia na ação antienvelhecimento da pele facial e contribui com o cuidado que todo o corpo merece, você encontra em nossa coleção",
  },
  {

    title: "Desodorante",
    text: "0% Aluminio, ação desodorante, Ação antioxidante, Ação anti-irritante, Ação calmante, Ação refrescante, sem parabenos, Sem Álcool, Vegano, 48hrs de proteção, limpa e evita irritações",
  },
];
